"use client";

import { motion } from "framer-motion";
import { useLang } from "@/contexts/language-context";
import { ShieldCheck, FileText, MessageSquareOff } from "lucide-react";

const COMPLIANCE = [
  {
    icon: ShieldCheck,
    title: { en: "Opt-in built in", es: "Opt-in incorporado" },
    sub: { en: "Customers opt in themselves at checkout, and Redy records whether each one agreed.", es: "Los clientes hacen opt-in ellos mismos al pagar, y Redy registra si cada uno aceptó." },
  },
  {
    icon: MessageSquareOff,
    title: { en: "STOP handling built in", es: "Manejo de STOP incorporado" },
    sub: { en: "Reply STOP and Redy processes the opt-out automatically; START opts them back in.", es: "Responden STOP y Redy procesa la baja automáticamente; con START vuelven a darse de alta." },
  },
  {
    icon: FileText,
    title: { en: "Opt-in status per customer", es: "Opt-in por cliente" },
    sub: { en: "See who agreed to texts right in your customer list, before you send anything.", es: "Ves quién aceptó recibir SMS en tu lista de clientes, antes de mandar nada." },
  },
];

export default function SmsComplianceScroll() {
  const { t } = useLang();

  return (
    <section className="relative py-32 px-6 bg-[#FAFAF8] overflow-hidden">
      <div className="relative max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 max-w-[760px] mx-auto"
        >
          <div className="text-[11px] font-black tracking-widest uppercase mb-4" style={{ color: "#D7263D" }}>
            {t("Opt-in and STOP, built in", "Opt-in y STOP, incorporados")}
          </div>
          <h2 className="text-4xl md:text-[64px] font-black tracking-[-0.03em] leading-[1.02] text-redy-charcoal">
            {t("Consent first. ", "Primero el consentimiento. ")}
            <span className="text-redy-charcoal/30">{t("Built in.", "Incorporado.")}</span>
          </h2>
          <p className="text-[16px] font-medium text-redy-secondary leading-relaxed mt-6">
            {t(
              "Texting customers without consent can get expensive under the TCPA. Redy builds in the opt-in at checkout and processes STOP automatically. You're still responsible for what your business sends — Redy gives you the tools to do it right.",
              "Mandar SMS sin consentimiento puede salir caro bajo la TCPA. Redy incorpora el opt-in al pagar y procesa el STOP automáticamente. Lo que tu negocio envía sigue siendo tu responsabilidad — Redy te da las herramientas para hacerlo bien."
            )}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-[1080px] mx-auto">
          {COMPLIANCE.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.title.en}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.6, delay: 0.1 * i, ease: [0.21, 0.47, 0.32, 0.98] }}
                className="bg-white border border-black/5 rounded-[20px] p-6 shadow-[0_20px_60px_rgba(0,0,0,0.04)]"
              >
                <div
                  className="w-11 h-11 rounded-[12px] flex items-center justify-center mb-5"
                  style={{ backgroundColor: "rgba(46,204,113,0.15)" }}
                >
                  <Icon className="w-5 h-5" style={{ color: "#2ECC71" }} />
                </div>
                <div className="text-[18px] font-black text-redy-charcoal mb-3 tracking-tight">
                  {t(item.title.en, item.title.es)}
                </div>
                <div className="text-[13px] font-medium text-redy-secondary leading-relaxed">
                  {t(item.sub.en, item.sub.es)}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
